import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { getContactName, getInitials, getPictureUrls } from "../helpers";
import { ContactWizardSceneProps } from "../types";

const THUMBNAIL_COUNT = 3;

/** Korak "Slike": galerija kontakta (prave slike ako ih ima), prijenos i gdje slike ostaju. */
const PicturesScene: React.FC<ContactWizardSceneProps> = ({ formValues }) => {
  const name = getContactName(formValues);
  const [cover, ...rest] = getPictureUrls(formValues);
  const thumbnails = Array.from({ length: THUMBNAIL_COUNT }, (_, index) => rest[index]);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-3">
          <div className="relative h-[11.2rem] rounded-md bg-gradient-to-br from-blue-100 to-blue-200 overflow-hidden">
            {cover ? (
              <img src={cover} alt="" className="absolute inset-0 w-full h-full p-[10px] object-contain" />
            ) : (
              <span className="absolute inset-0 flex items-center justify-center text-4xl font-bold text-blue-700/70">
                {getInitials(name)}
              </span>
            )}
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-white/90 text-[0.6rem] font-semibold text-slate-700 max-w-[90%] truncate">
              {name}
            </span>
          </div>
          <div className="mt-2 grid grid-cols-3 gap-2">
            {thumbnails.map((picture, index) => (
              <div key={index} className="flex items-center justify-center h-14 rounded-md bg-slate-100 overflow-hidden">
                {picture ? (
                  <img src={picture} alt="" className="w-full h-full object-contain" />
                ) : (
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <path d="M21 15l-5-5L5 21" />
                  </svg>
                )}
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-800">Prijenos slika</span>
            <span className="text-[0.65rem] font-semibold text-blue-600">2 / 3</span>
          </div>
          <div className="mt-3 flex items-center justify-center h-16 rounded-md border-2 border-dashed border-blue-200 bg-blue-50/50">
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 16V4M7 9l5-5 5 5M4 20h16" />
            </svg>
          </div>
          <div className="mt-3 h-1.5 rounded-full bg-slate-100">
            <div className="h-full w-2/3 rounded-full bg-gradient-to-r from-blue-500 to-sky-400" />
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Slike ostaju uz kontakt"
          subtitle="Logo, fotografija ili sken"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PicturesScene);
